

export const TOKEN_ABI = [
  { inputs: [], stateMutability: "nonpayable", type: "constructor" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousWallet",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newWallet",
        type: "address",
      },
    ],
    name: "AirdropWalletUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isExcluded",
        type: "bool",
      },
    ],
    name: "ExcludeFromFees",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldTxnAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newTxnAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "oldWalletAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newWalletAmount",
        type: "uint256",
      },
    ],
    name: "MaxTransactionAndWalletUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldTeamFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newTeamFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "oldLiquidityFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newLiquidityFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "oldAirdropFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newAirdropFee",
        type: "uint256",
      },
    ],
    name: "SellFeesUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "pair", type: "address" },
      { indexed: true, internalType: "bool", name: "value", type: "bool" },
    ],
    name: "SetAutomatedMarketMakerPair",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokensSwapped",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ethReceived",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokensIntoLiquidity",
        type: "uint256",
      },
    ],
    name: "SwapAndLiquify",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newAmount",
        type: "uint256",
      },
    ],
    name: "SwapTokensAtAmountUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousWallet",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newWallet",
        type: "address",
      },
    ],
    name: "TeamWalletUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "airdropWallet",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" },
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "buyTotalFees",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "deadAddress",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "subtractedValue", type: "uint256" },
    ],
    name: "decreaseAllowance",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "bool", name: "excluded", type: "bool" },
    ],
    name: "excludeFromFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "updAds", type: "address" },
      { internalType: "bool", name: "isEx", type: "bool" },
    ],
    name: "excludeFromMaxTransaction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "addedValue", type: "uint256" },
    ],
    name: "increaseAllowance",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "isExcludedFromFees",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxTransactionAmount",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxWallet",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "sellTotalFees",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_airdropWallet", type: "address" },
    ],
    name: "setAirdropWallet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "pair", type: "address" },
      { internalType: "bool", name: "value", type: "bool" },
    ],
    name: "setAutomatedMarketMakerPair",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_teamWallet", type: "address" }],
    name: "setTeamWallet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "swapEnabled",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "swapTokensAtAmount",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "teamWallet",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "sender", type: "address" },
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "uniswapV2Pair",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "uniswapV2Router",
    outputs: [
      {
        internalType: "contract IUniswapV2Router02",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "newTxnNum", type: "uint256" },
      { internalType: "uint256", name: "newMaxWalletNum", type: "uint256" },
    ],
    name: "updateMaxWalletAndTxnAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_teamFee", type: "uint256" },
      { internalType: "uint256", name: "_liquidityFee", type: "uint256" },
      { internalType: "uint256", name: "_airdropFee", type: "uint256" },
    ],
    name: "updateSellFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_newSwapAmount", type: "uint256" },
    ],
    name: "updateSwapTokensAtAmount",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  { stateMutability: "payable", type: "receive" },
];

export const KTL_ABI = [
  "function currentLeagueId() view returns(uint256)",
  "function rewardToken() view returns(address)",
  "function globalTradingGoalUsd() view returns(uint256)",

  "function getWallet(address user) view returns(tuple(bool qualified,bool claimed,uint256 firstBuyAt,uint256 kp,uint256 buyVolumeUsd,uint256 sellVolumeUsd,uint256 currentLeagueVolumeUsd,uint256 lifetimeVolumeUsd,uint256 archivedKp,uint256 totalRewardsEarned,uint256 totalRewardsClaimed,uint256 currentRank,uint8 tier,string username,uint256 lastClaimLeagueId,uint256 highestRank))",

  "function getWalletKpBreakdown(address user) view returns(uint256 currentLeagueKp,uint256 tier1PendingKp,uint256 tier2PendingKp,uint256 tier3PendingKp,uint256 totalPendingKp,uint256 totalKp)",

  "function getLeague(uint256 leagueId) view returns(tuple(uint256 id,uint256 startAt,uint256 endAt,uint256 finalizedAt,bool active,bool finalized,uint256 rewardPool,uint256 visibleLeaderboardSize,uint256 totalVolumeUsd,uint256 totalKp,uint256 totalBuyVolumeUsd,uint256 totalSellVolumeUsd,uint256 totalQualifiedWallets,uint256 totalClaimed,uint256 totalAllocated,uint256 unclaimedAmount,uint256 claimExpiresAt,bool unclaimedRecovered))",

  "function getTier(uint8 tierId) view returns(tuple(uint256 minWallets,uint256 rewardBps,uint256 qualifiedWallets,uint256 currentRewardPool,uint256 pendingRewardPool,uint256 currentLeagueKp,uint256 pendingKp,uint256 consecutivePendingLeagues,bool pending,bool claimable,uint256 totalCarriedRewardPool,uint256 previousTierStatus,uint256 previousLeagueSettlementStatus))",

  "function getGlobalStats() view returns(uint256 leagueId,uint256 rewardPool,uint256 totalVolumeUsd,uint256 totalKp,uint256 goalUsd,uint256 leaderboardSize)",

  "function getExtendedGlobalStats() view returns(uint256 claimExpiryValue,uint256 totalLifetimeVolume,uint256 totalEarned,uint256 totalClaimed,uint256 kindBurned,uint256 rewardPoolDeposited,uint256 pendingRewardPools,uint256 pendingKpTotal,uint256 pendingTiersCount)",

  "function getLeagueUserStats(uint256 leagueId,address user) view returns(uint256 kp,uint256 volumeUsd,uint256 claimableReward,bool joined)",

  "function getEstimatedReward(uint256 leagueId,address user) view returns(uint256 estimatedKind,uint256 tierTotalKp,uint8 tierId)",

  "function getEstimatedUsdReward(uint256 leagueId,address user,uint256 kindUsdPriceE18) view returns(uint256)",

  "function getClaimStatus(uint256 leagueId,address user) view returns(bool finalized,bool claimed,uint256 claimableAmount,uint256 finalizedAt,uint256 expiresAt,bool expired)",

  "function getClaimableReward(uint256 leagueId,address user) view returns(uint256)",

  "function hasClaimed(uint256 leagueId,address user) view returns(bool)",

  "function isClaimable(uint256 leagueId,address user) view returns(bool)",

  "function getLeagueParticipants(uint256 leagueId) view returns(address[])",

  "function getLeagueWinners(uint256 leagueId) view returns(address[],uint256[])",

  "function getClaimHistory(uint256 leagueId,address user) view returns(tuple(uint256 leagueId,uint256 allocated,uint256 claimed,bool claimedStatus,bytes32 txHash,uint256 claimedAt)[])",

  "function claimReward(uint256 leagueId)",

  "function setUsername(string username)",

  "function startLeague(uint256 startAt,uint256 endAt,uint256 visibleLeaderboardSize)",

  "function autoStartNextLeague(uint256 visibleLeaderboardSize)",

  "function finalizeLeague()",

  "function emergencyEndLeague()",

  "function depositRewardPool(uint256 amount)",

  "function setGlobalTradingGoal(uint256 value)",

  "function setKpPerUsd500(uint256 value)",

  "function setClaimExpiry(uint256 value)",

  "function setVisibleLeaderboardSize(uint256 value)",

  "function setTierMinimums(uint256 t1,uint256 t2,uint256 t3)",

  "function setRewardDistribution(uint256 bps1,uint256 bps2,uint256 bps3)",

  "function pause()",

  "function unpause()",

  
];

